import React, { useEffect, useState, } from 'react';
import axios from 'axios';
import { Modal, Input, message, Form,Select, } from 'antd';
import './index.less';

const { TextArea } = Input;

const EnterInput=({value,onChange,handleConfirm,handleSelect,showEnterList,showSearch,enterList})=>{

  return <div className="input enterpriseNameInput">
    <Input
      placeholder='请输入公司名称'
      value={value}
      type='text'
      onChange={onChange}
      className="input-child enterpriseName"
      suffix={showSearch?<div className='search' onClick={()=>handleConfirm()}>搜索</div>:<div className='search' style={{background:'#ffffff'}}></div>}
    />
    {showEnterList&&<div className='enterpriseList'>
      {enterList.map(v=>v&&<div key={v.reg_no} onClick={()=>handleSelect(v)} className='enterpriseList-item'>{v.name}</div>)}
    </div>}
  </div>
}

const LeaseModal = (props) => {

  const { canceLease, isShowLease} = props

  const [form] = Form.useForm();
  const nameValue = Form.useWatch('enterpriseName', form);

  const [css1, setCss1] = useState({});
  const [css2, setCss2] = useState({});
  const [css3, setCss3] = useState({});
  const [css4, setCss4] = useState({});
  const [css5, setCss5] = useState({});
  const [css6, setCss6] = useState({});
  const [font1, setFont1] = useState("");
  const [font2, setFont2] = useState("");
  const [font3, setFont3] = useState("");
  const [font4, setFont4] = useState("");
  const [font5, setFont5] = useState("");
  const [font6, setFont6] = useState("");
  const useTimeList = ['30天内', '1～6个月', '6个月以上']
  const [enterList,setEnterList]=useState([
    {
        "credit_no": "91330110MA2CGGEB1L",
        "reg_no": "330184000904934",
        "oper_name": "李昱龙",
        "name": "杭州脚本信息技术有限公司",
        "id": "11985d5f-d1ba-f885-c3f5-b2749e2739fd",
        "start_date": "2018-12-29"
    },
    {
        "credit_no": "91330110MADX83JDX8",
        "reg_no": "330110002213229",
        "oper_name": "欧阳熠",
        "name": "杭州免丫鲸供应链管理有限公司",
        "id": "3075a398-7954-9fb5-5a91-f0f533488556",
        "start_date": "2024-08-19"
    },
    {
        "credit_no": "91330110MA2KCD9K0T",
        "reg_no": "330184001413449",
        "oper_name": "杨代明",
        "name": "杭州妙鸦网络科技有限公司",
        "id": "77ec897a-4b5d-226f-2c91-4d51046a4712",
        "start_date": "2020-12-08"
    },
    {
        "credit_no": "91330110MA2KCD9J20",
        "reg_no": "330184001413432",
        "oper_name": "杨代明",
        "name": "杭州黑趣网络科技有限公司",
        "id": "86e9a8fe-7170-8cb0-ea3d-69d751d01019",
        "start_date": "2020-12-08"
    },
    {
        "credit_no": "91330110MA7JLMFB7E",
        "reg_no": "330110001701965",
        "oper_name": "欧阳熠",
        "name": "杭州妙鸦云信息技术有限公司",
        "id": "2f7ab582-725d-8174-be4d-6e685d5e4e6f",
        "start_date": "2022-02-24"
    },
    {
        "credit_no": "91330110MA2GYF8A4A",
        "reg_no": "330184001091248",
        "oper_name": "李昱龙",
        "name": "杭州指数增长信息技术有限公司",
        "id": "499d060d-ebaa-a954-1295-e8b3b0b06b40",
        "start_date": "2019-09-26"
    },
    {
        "credit_no": "92330110MA2GHD628W",
        "reg_no": "330184601408480",
        "oper_name": "林桃",
        "name": "慕鱼辅助脚本软件（杭州）淘宝店",
        "id": "a57aed7d-54fb-8c2c-7761-476c75c599f3",
        "start_date": "2018-12-25"
    },
    {
        "credit_no": "92330104MA2BR7795G",
        "reg_no": "330104600632823",
        "oper_name": "陈旭华",
        "name": "杭州市江干区兰彦文化创意工作室",
        "id": "58daee7b-9b0a-1c88-ca88-39bc0378272e",
        "start_date": "2015-05-15"
    },
    {
        "credit_no": "",
        "reg_no": "3301843003576",
        "oper_name": "朱友林",
        "name": "杭州余杭区百丈友林食品店",
        "id": "f1b99bfb-a238-763d-151f-2aa9ad44131d",
        "start_date": "-"
    }
])
  const [showSearch,setShowSearch]=useState(true)
  const [selectRnter,setSelectRnter]=useState('')
  const [showEnterList,setShowEnterList]=useState(false)
  const [serviceTime,setServiceTime]=useState('')

  

  useEffect(()=>{
    if(nameValue&&nameValue.length>3){
      setShowSearch(true)
    }else{
      setShowSearch(false)
    }
  },[nameValue])

  const changeCss1 = () => {
    if (css1.background === undefined) {
      setCss1({
        background: "#FEF7F6",
        borderRadius: "10px",
        border: "1px solid #ED0000",
      })
      setFont1("笔记本,")
    } else {
      setCss1({})
      setFont1("")
    }
  }

  const changeCss2 = () => {
    if (css2.background === undefined) {
      setCss2({
        background: "#FEF7F6",
        borderRadius: "10px",
        border: "1px solid #ED0000",
      })
      setFont2("台式电脑,")
    } else {
      setCss2({})
      setFont2("")
    }
  }

  const changeCss3 = () => {
    if (css3.background === undefined) {
      setCss3({
        background: "#FEF7F6",
        borderRadius: "10px",
        border: "1px solid #ED0000",
      })
      setFont3("打印机,")
    } else {
      setCss3({})
      setFont3("")
    }
  }

  const changeCss4 = () => {
    if (css4.background === undefined) {
      setCss4({
        background: "#FEF7F6",
        borderRadius: "10px",
        border: "1px solid #ED0000",
      })
      setFont4("手机,")
    } else {
      setCss4({})
      setFont4("")
    }
  }

  const changeCss5 = () => {
    if (css5.background === undefined) {
      setCss5({
        background: "#FEF7F6",
        borderRadius: "10px",
        border: "1px solid #ED0000",
      })
      setFont5("投影仪,")
    } else {
      setCss5({})
      setFont5("")
    }
  }

  const changeCss6 = () => {
    if (css6.background === undefined) {
      setCss6({
        background: "#FEF7F6",
        borderRadius: "10px",
        border: "1px solid #ED0000",
      })
      setFont6("其他,")
    } else {
      setCss6({})
      setFont6("")
    }
  }

  const submitForm = (data) => axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/consumer-zhifubao/aliPay/enterpriseUser/saveOrUpdateConsult',
    responseType: 'json',
    data
  })

  const onFinish = (values) => {
    const categoryNames = font1 + font2 + font3 + font4 + font5 + font6;
    const params={
      ...values,
      serviceTime,
      consultType: 1,
      consultSource:1,
      operation: 'add',
      creatorName: values.mobile,
      consultName: values.enterpriseName,
      categoryList:categoryNames.split(',').reduce((t,v)=>v?[...t,v]:t,[])
    }
    if(selectRnter){
      params.license=selectRnter.credit_no
    }
    return
    
    
    submitForm(params).then(res => {
      if (res?.data?.code === 1) {
        canceLease()
        message.success(res.data.msg);
      } else {
        values?.telephone ? message.error(res.data.msg) : message.error('请填写联系电话');
      }
    });
  };

  const handleGetEnterList=(data)=>axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/consumer-zhifubao/aliPay/enterprise/selectEnterpriseTripartitePage',
    responseType: 'json',
    data
  })


  const handleConfirm=()=>{
    handleGetEnterList({name:nameValue,pageNumber:1,pageSize:10,type:3}).then(res=>{
      console.log(res,'ssss');
      if(res.data.code===1){
        setEnterList(res.data.data?res.data.data.items:[])
        setShowEnterList(true)
      }else{
        return message.warn(res.data.msg)
      }
    })
  }

  // 选择企业
  const handleSelect=(v)=>{
    const data=JSON.parse(JSON.stringify(v))
    form.setFieldValue('enterpriseName',data.name)
    setSelectRnter(v)
    setShowEnterList(false)
  }

  // 选择时间
  const handleSelectTime=(v)=>{
    setServiceTime(v)
  }



  return (
    <Modal
      visible={isShowLease}
      onCancel={canceLease}
      footer={null}
      className="modalLease"
      getContainer={false}
      width={660}
      zIndex={99999999}
    >
      <div className="modalContainer">
        <Form name="basic" onFinish={onFinish} form={form}>
          <div className="title">企业租赁</div>
          <div className='formTitle'><span className='star'>＊</span>企业信息</div>
          <Form.Item name="enterpriseName">
            <EnterInput enterList={enterList}  handleConfirm={handleConfirm} handleSelect={handleSelect} showEnterList={showEnterList} showSearch={showSearch}/>
          </Form.Item>
          <Form.Item name="contacts">
            <div className="input">
              <Input type="text" className="input-child" placeholder="请输入联系人姓名" />
            </div>
          </Form.Item>
          <Form.Item name="mobile">
            <div className="input">
              <Input type="text" className="input-child" placeholder="请输入联系人手机号" />
            </div>
          </Form.Item>
          <div className="title-top"><span className='star'>＊</span>您意向租赁的产品（可多选）</div>
          <div className="icons">
            <div className="iconTop">
              <div className="left" style={css1} onClick={changeCss1}>
                <div className="left-pic"></div>
                <div className="left-font">笔记本</div>
              </div>
              <div className="center" style={css2} onClick={changeCss2}>
                <div className="center-pic"></div>
                <div className="center-font">台式电脑</div>
              </div>
              <div className="right" style={css3} onClick={changeCss3}>
                <div className="right-pic"></div>
                <div className="right-font">打印机</div>
              </div>
            </div>
            <div className="iconBottom">
              <div className="left" style={css4} onClick={changeCss4}>
                <div className="left-pic"></div>
                <div className="left-font">手机</div>
              </div>
              <div className="center" style={css5} onClick={changeCss5}>
                <div className="center-pic"></div>
                <div className="center-font">投影仪</div>
              </div>
              <div className="right" style={css6} onClick={changeCss6}>
                <div className="right-pic"></div>
                <div className="right-font">其他</div>
              </div>
            </div>
          </div>
          <div className='formTitle timeTitle'><span className='star'>＊</span>使用时长</div>
          <div className='usetime'>
            {useTimeList.map(v=><div key={v} className={`usetime-item ${v===serviceTime&&'activeTime'}`} onClick={()=>handleSelectTime(v)}>{v}</div>)}
          </div>
          <div className='formTitle timeTitle'>其它要求（选填，可不填）</div>
          <div className="textArea">
            <Form.Item name="content">
              <TextArea
                className="TextArea"
                showCount={true}
                bordered={false}
                maxLength={200}
                placeholder="其他要求，例如新旧程度等；推荐方案免费咨询，不收取任何费用，快速配置最合适的配置方案。"
              />
            </Form.Item>
          </div>
          {/* <div className="form">
            <div className="title-bottom">联系电话：</div>
            <Form.Item name="telephone">
              <div className="input">
                <Input type="text" className="input-child" placeholder="请输入手机号" />
              </div>
            </Form.Item>
          </div> */}
          <button className="button" htmlType="submit">提交委托</button>
        </Form>
      </div>
    </Modal>
  )
}

export default LeaseModal;